var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"property-address columns is-vcentered is-centered"},[_c('img',{staticClass:"property-address__icon",attrs:{"src":_vm.icon.svg,"alt":_vm.icon.type}}),_c('p',{staticClass:"property-address__address"},[_vm._v(" "+_vm._s(_vm.address)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }